import BaseService from "./BaseService"

export class MenuService extends BaseService{
	constructor() {
		super('/Menu');
	}
}